module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.17103/js/img/white_sprocket.svg"